// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';
import { Box, Card, CardContent, Skeleton } from '@mui/material';

import GuestRideCard from './GuestRideCard';

// TYPES ---------------------------------------------------------------- //

interface GuestRidesGridProps {
  rides: any[];
  loading: boolean;
  highlightedRideId: number | null;
  onHighlightClear: () => void;
}

// SKELETON ---------------------------------------------------------------- //

const GridSkeleton: React.FC = () => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
        lg: 'repeat(3, 1fr)',
      },
      gap: '20px',
      p: 3,
    }}
  >
    {Array.from({ length: 6 }).map((_, i) => (
      <Card key={i} sx={{ borderRadius: '12px' }}>
        <CardContent sx={{ p: 2.5 }}>
          <Skeleton width='60%' height={24} sx={{ mb: 1 }} />
          <Skeleton width='40%' height={18} sx={{ mb: 2 }} />
          <Skeleton width='100%' height={16} sx={{ mb: 1 }} />
          <Skeleton width='100%' height={16} sx={{ mb: 2 }} />
          <Skeleton width='80%' height={16} />
        </CardContent>
      </Card>
    ))}
  </Box>
);

// COMPONENT ---------------------------------------------------------------- //

const GuestRidesGrid: React.FC<GuestRidesGridProps> = ({ rides, loading, highlightedRideId, onHighlightClear }) => {
  if (loading && rides.length === 0) {
    return <GridSkeleton />;
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          sm: '1fr',
          md: 'repeat(2, 1fr)',
          xl: 'repeat(3, 1fr)',
        },
        gap: '18px',
        p: 3,
        minWidth: 0,
      }}
    >
      {rides.map((ride: any) => (
        <GuestRideCard
          key={ride.id}
          ride={ride}
          highlightedRideId={highlightedRideId}
          onHighlightClear={onHighlightClear}
        />
      ))}
    </Box>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default GuestRidesGrid;
